import {
  GROUP_BY_OPTIONS, PORTFOLIO_AGGREGATE_BY_OPTIONS,
  PORTFOLIO_SHOW_DEFAULT_VIEW,
  PORTFOLIO_UNIT_OPTIONS,
  SOURCE_OPTIONS, SOURCE_TRADES, UNIT_ENERGY, X_AXIS_DOMAIN_OPTIONS,
} from 'src/util/constants';
import getValidatedQueryParam from 'src/util/validation';

/**
 * Retrieve the query parameters for a portfolio show page from the URL.
 * @param {object} props
 * @param {object} props.match
 * @param {object} props.match.location
 * @param {object} props.match.location.query
 * @param {string} props.match.location.query.tz
 * @param {string} props.match.location.query.aggregateBy
 * @param {string} props.match.location.query.groupBy
 * @param {string} props.match.location.query.xAxisDomain
 * @param {string} props.match.location.query.source
 * @param {string} props.match.location.query.unit
 * @param {string} props.match.location.query.cardSelectedKeys
 * @returns {{
 *  aggregateBy: string,
 *  groupBy: string,
 *  xAxisDomain: string,
 *  source: string,
 *  unit: string,
 *  timezone: string,
 * }} the portfolio show params.
 */
const portfolioShowParams = (props) => {
  const { match } = props || {};
  const { location } = match || {};
  const { query } = location || {};
  const {
    tz: queryTimezone,
    aggregateBy: queryAggregateBy,
    groupBy: queryGroupBy,
    xAxisDomain: queryXAxisDomain,
    source: querySource,
    unit: queryUnit,
  } = query || {};

  // Validate URL query parameters to handle potential typos or invalid values
  const expectedQueryAggregatedBy = getValidatedQueryParam(
    queryAggregateBy,
    PORTFOLIO_AGGREGATE_BY_OPTIONS,
  );
  const expectedQueryGroupBy = getValidatedQueryParam(queryGroupBy, GROUP_BY_OPTIONS);
  const expectedQueryXAxisDomain = getValidatedQueryParam(queryXAxisDomain, X_AXIS_DOMAIN_OPTIONS);
  const expectedQuerySource = getValidatedQueryParam(querySource, SOURCE_OPTIONS);
  const expectedQueryUnit = getValidatedQueryParam(queryUnit, PORTFOLIO_UNIT_OPTIONS);

  return {
    aggregateBy: expectedQueryAggregatedBy
      ? queryAggregateBy : PORTFOLIO_SHOW_DEFAULT_VIEW.aggregateBy,
    groupBy: expectedQueryGroupBy
      ? queryGroupBy : PORTFOLIO_SHOW_DEFAULT_VIEW.groupBy,
    xAxisDomain: expectedQueryXAxisDomain
      ? queryXAxisDomain : PORTFOLIO_SHOW_DEFAULT_VIEW.xAxisDomain,
    source: expectedQuerySource ? querySource : SOURCE_TRADES,
    unit: expectedQueryUnit ? queryUnit : UNIT_ENERGY,
    timezone: queryTimezone,
  };
};
export default portfolioShowParams;
